<script setup lang="ts">
import { useAbility } from '@casl/vue';
import AskAiButton from './AskAiButton.vue';
import TopMapToolbar from './TopMapToolbar.vue';

defineProps({
  showAskAiButton: {
    type: Boolean,
    default: true,
  },
});

const { can } = useAbility();
</script>

<template>
  <TopMapToolbar>
    <template #start>
      <slot name="filters" />
    </template>
    <template #end>
      <AskAiButton
        v-if="can('use', 'Ai') && showAskAiButton"
        class="hidden sm:flex"
      />
    </template>
  </TopMapToolbar>
</template>
